import React, { Component } from "react";
import "./DirectDebit2.css";
import { handleProgress } from "../../../utils/handleProgress";
import DotsLoader from "../../Loader/DotsLoader/DotsLoader";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import { SpeakerContext } from "../../../context/SpeakerContext";
import { Button } from 'unified-ui-components-library'


class DirectDebitNew extends Component {
    state = {
        disclaimerChecked: false,
        disclaimerValue: "No",
        loading: false,
    };

    handleCheckbox = (value) => {
        if (value === true) {
            this.setState({ disclaimerChecked: true, disclaimerValue: "Yes" });
        } else {
            this.setState({ disclaimerChecked: false, disclaimerValue: "No" });


        }

    };

    componentDidMount = () => {
        handleProgress(60)
        this.setState({ loading: true });
        const { handleAudioIconDisplay } = this.context
        handleAudioIconDisplay(false)
        let debitDetails = JSON.parse(localStorage.getItem("digitalDebitData"));
        console.log(debitDetails);
        this.setState({ digitalDebit: debitDetails });
        console.log(this.state.digitalDebit)
        this.setState({ loading: false });
    };


    render() {
        const { handleSubmit } = this.props
        const { digitalDebit, loading, disclaimerChecked } = this.state
        return (
            <>{loading && <DotsLoader msg={this.props.t('Please wait')} />}
                {this.state.digitalDebit && (
                    <div className="dd-container">
                        <div className="dd-heading">
                            <h2>{this.props.t("Auto debit confirmation")} </h2>
                            <p>{this.props.t("review_bank_details")}</p>
                        </div>
                        <div className="dd-main-cntnr">
                            <div className="dd-details">

                                <div className="dd-user-info">

                                    <div>
                                        <div className="dd-detail-container">
                                            <p className="dd-userdata">{this.props.t(digitalDebit.accountDetail[2].accountLabel)} </p>
                                            <p className="dd-userdata-detail">
                                                {digitalDebit.accountDetail[2].accountValue}
                                            </p>
                                        </div>
                                        <div className="dd-detail-container">
                                            <p className="dd-userdata">{this.props.t(digitalDebit.accountDetail[0].accountLabel)} </p>
                                            <p className="dd-userdata-detail">
                                                {digitalDebit.accountDetail[0].accountValue}
                                            </p>
                                        </div>
                                        <div className="dd-detail-container">
                                            <p className="dd-userdata">{this.props.t(digitalDebit.accountDetail[4].accountLabel)} </p>
                                            <p className="dd-userdata-detail">
                                                {digitalDebit.accountDetail[4].accountValue}
                                            </p>
                                        </div>
                                        <div className="dd-detail-container">
                                            <p className="dd-userdata">{this.props.t(digitalDebit.accountDetail[6].accountLabel)} </p>
                                            <p className="dd-userdata-detail">
                                                {digitalDebit.accountDetail[6].accountValue}
                                            </p>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="dd-detail-container">
                                            <p className="dd-userdata">{this.props.t(digitalDebit.accountDetail[3].accountLabel)} </p>
                                            <p className="dd-userdata-detail">
                                                {digitalDebit.accountDetail[3].accountValue}
                                            </p>
                                        </div>

                                        <div className="dd-detail-container">
                                            <p className="dd-userdata">{this.props.t(digitalDebit.accountDetail[1].accountLabel)} </p>
                                            <p className="dd-userdata-detail">
                                                {digitalDebit.accountDetail[1].accountValue}
                                            </p>
                                        </div>

                                        <div className="dd-detail-container">
                                            <p className="dd-userdata">{this.props.t(digitalDebit.accountDetail[5].accountLabel)} </p>
                                            <p className="dd-userdata-detail">
                                                {digitalDebit.accountDetail[5].accountValue}
                                            </p>
                                        </div>
                                    </div>

                                </div>

                            </div>

                        </div>
                        <div className="dd-note">
                            <p className="dd-note-para">
                                {digitalDebit.accountDisclaimer}
                            </p>
                            <p className="dd-note-para">
                                {this.props.t("direct_debit_note")}
                            </p>
                            <div className="dd-form-check">
                                <label className="dd-form-check-input">
                                    <input
                                        onChange={(event) =>
                                            this.handleCheckbox(event.target.checked)
                                        }
                                        value={disclaimerChecked}

                                        type="checkbox"
                                        id="checkbox"
                                        checked={disclaimerChecked}
                                    />
                                    <span className="dd-checkmark"></span>
                                </label>

                                <p className="checkbox-text">
                                  {this.props.t("I authorize Max Life Insurance Company Limited to auto debit recurring premium payments using this payment method.")}
                                </p>
                            </div>
                        </div>
                        <div className="dd-submit-cntnr">

                            <div className="dd-btn-cntnr">

                                <Button
                                    // className=" btn-primary dd-submit-btn"
                                    onClick={handleSubmit}
                                    disabled={!disclaimerChecked}
                                    buttonType="primary"
                                    width="264"
                                >
                                    {this.props.t("Confirm & Proceed")}
                                </Button>
                            </div>
                        </div>
                    </div>)}
            </>
        );
    }
}
export default compose(
    withRouter,
    connect(null),
    withTranslation()
)(DirectDebitNew);

DirectDebitNew.contextType = SpeakerContext
